import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {sendEmail, resetSendEmail, reseGetContactsStatus} from "../../store/reducers/ContactsSlice";
import {RequestStatus} from "../../utils/Enums";

interface SendEmailStep3Props {
}

export const SendEmailStep3: React.FC<SendEmailStep3Props> = () => {

    const dispatch = useAppDispatch();
    const contactsState = useAppSelector((state) => state.contacts);

    const [subject, setSubject] = useState<string>("");
    const [content, setContent] = useState<string>("");
    const [success, setSuccess] = useState<boolean>(false);

    const sendEmailStatus = contactsState.sendEmailStatus;

    useEffect(() => {

        if ( sendEmailStatus === RequestStatus.Success ) {
            setSuccess(true);
            dispatch(resetSendEmail());
        }

    },[sendEmailStatus])

    const handleContactButton = () => {
        setSubject(subject + "[contact]");
    };

    const handleButtonClick = (text: string) => {
        const textarea = document.getElementById("wysiqyg") as HTMLTextAreaElement;
        const { selectionStart, selectionEnd } = textarea;
        const newContent =
            content.substring(0, selectionStart) +
            text +
            content.substring(selectionEnd, content.length);
        setContent(newContent);
        textarea.focus();
        textarea.setSelectionRange(selectionStart + text.length, selectionStart + text.length);
    };

    const send = () => {
        dispatch(sendEmail({ subject, content }));
    }

    return (
        <LoggedInView fullWidth={false}>
            <h1>Saada E-mail</h1>
            {success && <div className="message msg-ok">
              <div>
                <h2>Kirjad saadetud</h2>
              </div>
            </div>}
            {!success &&
            <div className="form">
              <form method="post">
                <h2><span>Saada mail</span></h2>
                <table className="form">
                  <tbody>
                  <tr>
                    <th>Pealkiri:</th>
                    <td>
                      <input
                        type="text"
                        id="contact_name"
                        name="subject"
                        className="text"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                      />
                      <input
                        type="button"
                        onClick={handleContactButton}
                        value="[contact]"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Adressaadid:</th>
                    <td>
                        {contactsState?.contacts?.map((contact) => (
                            <React.Fragment key={contact.id}>
                                <strong>{contact.name}</strong> - {contact.name} (
                                {contact.email})<br/>
                            </React.Fragment>
                        ))}
                    </td>
                  </tr>
                  <tr>
                    <th>Sisu:</th>
                    <td>
                      <button style={{border: "1px solid black", marginRight: "5px"}} type={'button'}
                              onClick={() => handleButtonClick("[signature]")}>Signature
                      </button>
                      <button style={{border: "1px solid black", marginRight: "5px"}} type={'button'}
                              onClick={() => handleButtonClick("[contact]")}>Contact
                      </button>
                      <br/><br/>
                      <textarea
                        id="wysiqyg"
                        name="content"
                        style={{width: '500px', height: '200px'}}
                        cols={60}
                        rows={10}
                        className="small"
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th></th>
                    <td>
                      <div className="action clear">
                        <p>
                          <button type="button" onClick={send}>
                      <span>
                        <strong>Saada </strong>
                      </span>
                          </button>
                        </p>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </form>
            </div>
            }

        </LoggedInView>
    );

}